<script setup>
import { ref, computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';

import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';
import HiddenMediaNotice from '../HiddenMediaNotice.vue';

defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});
const hasError = ref(false);
const showGallery = ref(false);

const { filteredCurrentChatAttachments, contentAttributes } =
  useMessageContext();

// Mídia marcada como imprópria: oculta até o agente pedir para ver (só para ele).
const isRevealed = ref(false);
const hiddenMedia = computed(() => contentAttributes.value?.hiddenMedia);
const isMediaHidden = computed(() => !!hiddenMedia.value && !isRevealed.value);

const handleError = () => {
  hasError.value = true;
};
</script>

<template>
  <HiddenMediaNotice
    v-if="isMediaHidden"
    compact
    :hidden-media="hiddenMedia"
    @reveal="isRevealed = true"
  />
  <div
    v-else
    class="size-[72px] overflow-hidden contain-content rounded-xl cursor-pointer"
    @click="showGallery = true"
  >
    <div
      v-if="hasError"
      class="flex flex-col items-center justify-center gap-1 text-xs text-center rounded-lg size-full bg-n-alpha-1 text-n-slate-11"
    >
      <Icon icon="i-lucide-circle-off" class="text-n-slate-11" />
      {{ $t('COMPONENTS.MEDIA.LOADING_FAILED') }}
    </div>
    <img
      v-else
      class="object-cover w-full h-full skip-context-menu"
      :src="attachment.dataUrl"
      @error="handleError"
    />
  </div>
  <GalleryView
    v-if="showGallery && !isMediaHidden"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="handleError"
    @close="() => (showGallery = false)"
  />
</template>
